import React, { Fragment, useEffect, useState } from "react";
import api from "../../../../api";
import { ContainerLoader } from "../../../../components/loader";
import { IActivityListingDetails } from "../../../../core";
import { useLeadActivities } from "../../../../core/hooks/useLeadActivities";

import { ActivityItemBuilder } from "./activity-item-builder";
import UserLogs from "../logs/user-logs";

interface IDoneActivityProps {
  activityDetails?: IActivityListingDetails;
  leadIds?: string[];
  allActvity?: boolean;
  customerId?: string;
  companyId?: string;
}

export const DoneActivities: React.FunctionComponent<IDoneActivityProps> = (
  props
) => {
  const {
    leadState,
    setFilter,
    getCompletedActivities,
    getCompletedActivitiesAll,
  } = useLeadActivities(api.lead);

  const expectedOwnerId =
    props.allActvity && props.leadIds
      ? props.companyId || props.leadIds.join(",")
      : leadState.leadDetails?._id;
  const isForCurrentLead = props.activityDetails?.ownerId === expectedOwnerId;

  const activities = isForCurrentLead ? props.activityDetails?.data ?? [] : [];
  const activeFilter = props.activityDetails?.filter ?? "all";
  const isActivitiesLoading =
    (props.activityDetails?.isLoading ?? false) || !isForCurrentLead;
  const [isRendered, setIsRendered] = useState(false);

  const details = props.activityDetails;
  const filter: { displayText: string; key: string }[] = [
    { displayText: "All", key: "all" },
    { displayText: "Note", key: "note" },
    { displayText: "Activity", key: "activity" },
    { displayText: "Files", key: "file" },
    // { displayText: 'Invoice', key: 'invoice' },
    { displayText: "Change Log", key: "changeLog" },
  ];
  useEffect(() => {
    setIsRendered(true);
  }, []);
  useEffect(() => {
    if (activeFilter !== "changeLog") {
      loadActivities(1);
    }
  }, [activeFilter]);

  const loadActivities = (page: number) => {
    if (props.allActvity && props.leadIds) {
      if ((props.leadIds?.length > 0 || props.companyId) && isRendered) {
        if (props.companyId) {
          getCompletedActivitiesAll([props.companyId], activeFilter, page, 'company');
        } else {
          getCompletedActivitiesAll(props.leadIds, activeFilter, page);
        }
      }
    } else {
      if (isRendered) {
        getCompletedActivities(leadState.leadDetails?._id!, activeFilter, page);
      }     
    }
  };

  return (
    <Fragment>
      <li className="text-center mb-4 pb-2 mb-3 position-relative ">
        <span className="bg-gray-300 rounded-pill px-2 font-xxs text-uppercase">
          Done
        </span>
      </li>
      <li className="d-flex mb-4 position-relative ">
        <div className="activity-icon d-flex align-items-center justify-content-center mr-2 mt-2"></div>
        <ul
          className="nav tab-underline mb-0 border-bottom font-xs font-weight-semibold col"
          id="activity-tab"
          role="tablist"
        >
          {filter.map((p, index) => {
            return (
              <li
                onClick={() => {
                  setFilter(p.key);
                }}
                className="nav-item mr-4"
                role="presentation"
              >
                <a
                  className={
                    "nav-link position-relative px-0 py-2 text-gray-600 cursor-pointer " +
                    (activeFilter === p.key ? "active" : "")
                  }
                  id={p + "-tab"}
                  data-toggle="pill"
                  // href={'#' + p}
                  role="tab"
                  aria-controls={p.key}
                  aria-selected="true"
                >
                  <span className="py-1 d-inline-flex">{p.displayText}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </li>
      {activities.length === 0 &&
        !isActivitiesLoading &&
        activeFilter !== "changeLog" && (
          <li className="text-center mb-4 pb-2 mb-3 position-relative ">
            <span className="px-2 font-sm text-uppercase">No Activities</span>
          </li>
        )}
      <Fragment>
        {activeFilter === "changeLog" ? (
          <UserLogs
            leadId={leadState.leadDetails?._id}
            customerId={props.customerId}
            companyId={props.companyId}
          ></UserLogs>
        ) : (
          <div className="overflow-auto">
            {activities.map((p, index) => {
              return (
                <div key={"done-activities-" + index}>
                  {ActivityItemBuilder.builder[p.type] != null &&
                    ActivityItemBuilder.builder[p.type](p, props.leadIds)}
                </div>
              );
            })}
            {!isActivitiesLoading &&
              activities.length < (details?.totalCount ?? 0) &&
              activities.length !== 0 && (
                <div className="text-center">
                  <span
                    onClick={() => {
                      loadActivities((details?.page ?? 0) + 1);
                    }}
                    className="rounded-pill px-2 font-xxs text-uppercase cursor-pointer text-primary font-weight-semibold"
                  >
                    Load more
                  </span>
                </div>
              )}
            {isActivitiesLoading && <ContainerLoader></ContainerLoader>}
          </div>
        )}
      </Fragment>
    </Fragment>
  );
};
